import React from 'react'
import Navbar from '../layout/newNavbar'
import './css/projects.scss'

function Projects() {
    return (
        <section className="projects">
            <Navbar/>
            <div></div>
        </section>
    )
}

export default Projects
